// SÉCURITÉ : on n'envoie PLUS le refresh token depuis le client (credential).
// On passe l'identifiant du mentor ; le serveur résout le token et ne renvoie
// que les créneaux occupés (titres masqués pour les non-propriétaires).
export async function getEvents(mentorId, month = new Date()) {
    const response = await fetch("/api/calendars/get-events", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            mentorId,
            month,
        }),
    });

    const fetchedData = await response.json();

    if (!response.ok) {
        return false;
    } else {
        return fetchedData.events;
    }
}

export async function createEvent(refreshToken, call) {
    const response = await fetch("/api/calendars/create-event", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            refreshToken,
            call,
        }),
    });

    const fetchedData = await response.json();

    if (!response.ok) {
        return false;
    } else {
        return true;
    }
}
